var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "attachments-container" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v("\n    " + _vm._s(_vm.titleText) + "\n  "),
    ]),
    _vm._v(" "),
    _c("table", [
      _c("thead", [
        _c("tr", [
          _c("th", [_vm._v(_vm._s(_vm.numberFieldName))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("tender.attachment.document")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("summary.awardedDate")))]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.numberArray, function (number, index) {
          return _c("tr", { key: index }, [
            _c("td", [
              _vm.isTender &&
              _vm.filterProject(number) &&
              _vm.hasReadProjectAccess
                ? _c(
                    "a",
                    {
                      staticClass: "project-link",
                      on: {
                        click: function () {
                          return _vm.navToProject(number)
                        },
                      },
                    },
                    [_vm._v(_vm._s(number))]
                  )
                : !_vm.isTender && _vm.isHKlandUser && _vm.maximoProjectHref
                ? _c(
                    "a",
                    {
                      staticClass: "underline",
                      attrs: { href: _vm.maximoProjectHref, target: "_blank" },
                    },
                    [_vm._v("\n            " + _vm._s(number) + "\n          ")]
                  )
                : _c("span", [
                    _vm._v("\n            " + _vm._s(number) + "\n          "),
                  ]),
            ]),
            _vm._v(" "),
            _c(
              "td",
              _vm._l(_vm.poFiles[number], function (file) {
                return _c("ul", { key: file.id }, [
                  _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "underline",
                        staticStyle: { "word-break": "break-all" },
                        attrs: { target: "po_attachment" },
                        on: {
                          click: function ($event) {
                            return _vm.downloadFile(file.id)
                          },
                        },
                      },
                      [_vm._v(_vm._s(file.filename))]
                    ),
                  ]),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.awardedDate || _vm.$t("emptyValue")))]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }